import React from "react";
import Container from "Components/Container/Container";

const MobileLanding = ({ data }) => {
  return (
    <section className="lg:hidden">
      <div>
        {data.map(({ title, description, image }, index) => (
          <div
            style={{ backgroundImage: `url(${image})` }}
            key={index}
            className="py-48 background"
          >
            <Container>
              <div className="bg-[#000000bb] p-6">
                <h4 className="bebas text-4xl mb-2 text-font">{title}</h4>
                <p className="text-white">{description}</p>
              </div>
            </Container>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MobileLanding;
